import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteEstadoDelCredito,
  getEstadosDelCredito,
  patchEstadoDelCredito,
  postEstadoDelCredito,
} from 'api/pae/estadosDelCredito';
import { capitalize } from 'utils/normalizers';

export const permissionConfig = {
  permissionModel: 'estadodelcreditopae',
};

// eslint-disable-next-line react/prop-types
const EstadosDelCredito = ({ permission }) => (
  <PlainCRUD
    title="Estado del Credito"
    get={getEstadosDelCredito}
    post={postEstadoDelCredito}
    patch={patchEstadoDelCredito}
    delete={deleteEstadoDelCredito}
    permission={permission}
    disabledStateField
    tableProps={{
      allowColumnSelector: false,
      deleteText: 'Cancelar',
    }}
    fields={[
      {
        ...defaultFields.clave,
        autoGenerate: true,
      },
      {
        ...defaultFields.descripcion,
        normalize: (value) => capitalize(value),
      },
      {
        name: 'documento',
        label: 'Documento',
        colWidth: 200,
        normalize: (value) => capitalize(value),
      },
      {
        ...defaultFields.observaciones,
        required: false,
        type: 'textarea',
        autoSize: { minRows: 4, maxRows: 4 },
      },
    ]}
  />
);

export default EstadosDelCredito;
